import englishMessages from "jazasoft/lib/i18n/default-messages/js-language-english";

const flowInfoFields = {
  poRef: "ERP No",
  seasonName: "Season",
  customerName: "Customer",
  flowRef: "Line Id",
  delFlowRef: "Delivery Line Id",
  customerFlowRef: "BPO",
  style: "Style Name",
  styleNo: "Style No",
  styleImage: "Style Image",
  color: "Style Color",
  fit: "Fit",
  productId: "Product",
  product: { name: "Product" },
  productName: "Product",
  ratio: "Ratio",
  destination: "Destination",
  delMode: "Delivery Mode",
  gender: "Gender",
  sleeveType: "Sleeve Type",
  exFactoryDate: "Delivery Date",
  orderQty: "Order Qty",
  fpoQty: "FPO Qty",
  uom: "UOM",
  extra: "Extra Ship (%)",
  status: "Status",
  customField1: "Custom Field1",
  customField2: "Custom Field2",
  customField3: "Custom Field3",
  bundleOrderNo: "Bundle Order No"
};

const partFields = {
  partName: "Part",
  placement: "Placement",
  ocu: "BOM CU",
  bomCu: "BOM CU",
  uom: "UOM"
};

const orderFields = {
  poRef: "ERP No",
  customerPoRef: "Customer ERP No",
  products: "Products",
  styles: "Styles",
  seasonId: "Season",
  seasonName: "Season",
  customerId: "Customer",
  customerName: "Customer",
  color: "Style Color",
  productId: "Product",
  season: { name: "Season" },
  customer: { name: "Customer" },
  totalQty: "Total Qty",
  desc: "Description",
  state: "Status",
  partName: "Part",
  part: partFields,
  flowInfo: flowInfoFields,
  cutPlanRemarks: "cut Plan Remarks",
  selector: ""
};

const rollFields = {
  consignment: "Consignment \nNo",
  supplierRollNo: "Supplier Roll No",
  factoryRollNo: "Factory Roll No",
  rollNo: "Roll No",
  length: "Length",
  weight: "Weight",
  gsm: "GSM",
  width: "Width",
  warpShrValue: "Length \nShrinkage Value",
  weftShrValue: "Width \nShrinkage Value",
  warpShrPercent: "Length \nShrinkage (%)",
  weftShrPercent: "Width \nShrinkage (%)",
  warpPattern: "Length Pattern (%)",
  weftPattern: "Width Pattern (%)",
  blanketQty: "Blanket Qty",
  patternNo: "Pattern No.",
  shade: "Shade",
  csv: "CSV",
  skewnessValue: "Skewness (%)",
  skewness: "Skewness Group",
  rackNo: "Rack No",
  qcStatus: "QC Status",
  invStatus: "Inv. Status",
  userRemarks: "Remarks"
};

const en = {
  ...englishMessages,
  app_name_short: "CUT PLAN",
  app_name_full: "WFX - Cutting Solutions",
  dashboard: "Dashboard",
  forbidden: {
    title: "Forbidden",
    message: "Access Denied. You do not have enough privilege for this page."
  },
  resources: {
    dashboard: {
      fields: {
        poRef: "Po Ref",
        color: "Color",
        part: "Part",
        lot: "Lot",
        widthDeviation: "Width Deviation",
        fabric: "Fabric",
        mill: "Mill",
        avgLength: "Avg. Length",
        efficiency: "Efficiency",
        repeat: "Repeat",
        fabDirection: "Fab. Direction",
        csv: "CSV",
        actualWidth: "Actual Width"
      }
    },
    "order-status": {
      name: "Order Status",
      fields: {}
    },
    cuChecklists: {
      name: "CU Checklist |||| CU Checklist",
      fields: {
        cuChecklistId: "CU Checklist Id",
        "customer.name": "Customer",
        "season.name": "Season",
        "product.name": "Product",
        createdDate: "Created Date",
        createdBy: "Created By",
        state: "Status"
      }
    },
    costings: {
      name: "Costing |||| Costing",
      fields: {
        cstId: "Costing Id",
        "customer.name": "Customer",
        "product.name": "Product",
        "season.name": "Season",
        createdDate: "Created Date",
        createdBy: "Created By",
        state: "Status",
        techSheets: "Tech Sheets"
      }
    },
    estimations: {
      name: "Estimation |||| Estimation",
      fields: {
        estId: "Estimation Id",
        poRef: "ERP No",
        customerPoRef: "Customer ERP No",
        fit: "Fit",
        techSheet: "Tech Sheet",
        remarks: "Remarks",
        createdDate: "Created Date",
        createdBy: "Created By",
        state: "Status",
        colors: "Colors",
        "customer.name": "Customer",
        "product.name": "Product",
        "season.name": "Season"
      }
    },
    "order-mngmt": {
      name: "Order Management"
    },
    orders: {
      name: "Orders",
      action: {
        next: "Next"
      },
      cardHeader: {
        summary: "Order Summary",
        detail: "Order Details"
      },
      button: {
        export_shell: "Export (Shell)",
        export: "Export"
      },
      fields: {
        ...orderFields,
        ...flowInfoFields
      },
      flowInfo: flowInfoFields,
      part: {
        name: "Part",
        fields: {
          id: "Id",
          serial: "Serial No",
          partName: "Part Name",
          placement: "Placement",
          ocu: "BOM Consumption",
          bomCu: "BOM Consumption",
          uom: "UOM",
          bomFabColor: "BOM Fabric Color",
          fabOrderQty: "Fabric Order Qty",
          bomItemCode: "BOM Item Code"
        }
      },
      sizeBreakup: {
        name: "Size Breakup",
        fields: {
          id: "Id",
          serialNo: "Serial No",
          serial: "Serial No",
          sizeGroup: "Size Group",
          size: "Size",
          qty: "Quantity"
        }
      }
    },
    fpo: {
      name: "Factory Production Order |||| Factory Production Orders",
      fields: {
        fpo: "FPO",
        fpoLevel: "FPO Level",
        primaryUnitId: "Unit",
        unitId: "Unit",
        poRef: "ERP No",
        customerName: "Customer",
        customer: "Customer",
        season: "Season",
        seasonName: "Season",
        products: "Product",
        styles: "Style",
        colors: "Color",
        destinations: "Destination",
        deliveryDates: "Delivery Date",
        customerFlowRefs: "BPO",
        flowRefs: "Line Id",
        delFlowRefs: "Delivery Line ID",
        orderQty: "Order Qty",
        fpoQty: "FPO Qty",
        status: "Status"
      }
    },
    fabrics: {
      name: "Item Master",
      fields: {
        itemCode: "Item Code",
        itemDesc: "Item Description",
        articleName: "Article Name",
        gsm: "GSM",
        classification: "Classification",
        fabricCategoryId: "Fabric Category",
        fabricCategoryName: "Fabric Category",
        fabricCategory: { name: "Fabric Category" },
        fabricPatternId: "Fabric Pattern",
        fabricPatternName: "Fabric Pattern",
        fabricPattern: { name: "Fabric Pattern" },
        repeatLength: "Repeat - Length (CM)",
        repeatWidth: "Repeat - Width (CM)",
        construction: "Count Construction",
        content: "Content",
        remarks: "Remarks",
        fabricColors: "Colors",
        color: {
          color: "Fabric Color",
          swatchImage: "Swatch Image"
        }
      },
      pageHeader: {
        create: "Create Fabric"
      },
      errors: {
        repeat_length_required: "Repeat Length is Required",
        repeat_width_required: "Repeat Width is Required",
        repeat_in_only_one_direction: "Stripes fabric can have repeat in only one direction."
      }
    },
    invoices: {
      name: "Fabric GRN",
      fields: {
        invoiceNo: "Invoice No",
        erpInvoiceNo: "ERP Invoice No",
        grn: "GRN No",
        invoiceQty: "Total Invoice Qty",
        warehouse: "Warehouse",
        warehouses: "Warehouses",
        supplierId: "Supplier",
        supplierName: "Supplier",
        supplier: { name: "Supplier" },
        association: {
          orderId: "ERP No",
          productId: "Product",
          style: "Style Name",
          color: "Style Color",
          partId: "Part",
          ocu: "BOM CU",
          bomCu: "BOM CU",
          orderQty: "Order Qty",
          extra: "Extra Ship (%)",
          fabricRequired: "Required \nFabric",
          extraFabricRequired: "Required \nFabric (Extra)",
          alreadyAssociatedQty: "Already \nAssociated Qty",
          qty: "Association \nQty",

          //System Activity Fields
          invoiceNo: "Invoice No",
          colorShade: "Color Shade",
          itemCode: "Item Code",
          fabColor: "Fabric Color",
          poRef: "ERP No",
          productName: "Product",
          styleColor: "Style Color",
          part: "Part"
        }
      },
      pageHeader: {
        create: "Create Invoice",
        edit: "Edit Invoice",
        view: "View Invoice"
      }
    },
    fabricItems: {
      fields: {
        invoiceNo: "Invoice No.",
        erpInvoiceNo: "ERP Invoice No.",
        fabricId: "Item Code",
        itemCode: "Item Code",
        itemDesc: "Item Description",
        articleName: "Article Name",
        classification: "Classification",
        construction: "Count Construction",
        content: "Content",
        color: "Fabric Color",
        poRef: "ERP No",
        orderId: "ERP No",
        fpo: "FPO",
        orderQty: "Fab. Order Qty",
        invoiceQty: "Invoice Qty",
        grn: "GRN",
        grnDate: "GRN Date",
        grnQty: "GRN Qty",
        rollCount: "Roll Count",
        blanketQty: "Blanket Qty \nper Roll",
        orderingWidth: "Booking Width",
        orderingGsm: "Booking GSM",
        orderingWarpShrinkage: "Booking Max. \nWarp Shrinkage",
        orderingWeftShrinkage: "Booking Max. \nWeft Shrinkage"
      }
    },
    quality: {
      name: "Quality Control |||| Quality Control",
      fields: {
        ...orderFields,
        invoice: {
          invoiceNo: "Invoice No.",
          erpInvoiceNo: "ERP Invoice No.",
          itemCode: "Item Code",
          itemDesc: "Item Description",
          articleName: "Article Name",
          classification: "Classification",
          construction: "Count Construction",
          content: "Content",
          color: "Fabric Color",
          associatedQty: "Associated Qty",
          allocatedQty: "Allocated Qty"
        }
      }
    },
    rolls: {
      fields: rollFields
    },
    "fab-release": {
      name: "Fabric Release",
      fields: {
        poRef: "ERP No",
        customerPoRef: "Customer ERP No",
        flowRefs: "Line Ids",
        flowRef: "Line Id",
        delFlowRefs: "Delivery Line ID",
        delFlowRef: "Delivery Line Id",
        customerFlowRefs: "BPOs",
        customerFlowRef: "BPO",
        customer: "Customer",
        productName: "Product",
        style: "Style",
        styles: "Styles",
        colors: "Colors",
        color: "Color",
        inseams: "Inseams",
        inseam: "Inseam",
        destinations: "Destinations",
        destination: "Destination",
        deliveries: "Deliveries",
        deliveryDate: "Delivery Date",
        part: "Part",
        lotValue: "Lot",
        orderQty: "Order Qty",
        itemCode: "Item Code",
        itemDesc: "Item Description",
        articleName: "Article Name",
        allocatedQty: "Allocated Qty",
        releasedQty: "Released Qty"
      },
      history: {
        txn: "Transaction No",
        challanNo: "Challan No",
        releasedQty: "Released Qty",
        releasedDate: "Released Date",
        releasedBy: "Released By",
        status: "Inventory Status"
      },
      releasedRolls: {
        rollNo: "Factory Roll No",
        supplierRollNo: "Supplier Roll No",
        invStatus: "Inv. Status",
        length: "Length",
        width: "Cuttable Width",
        shade: "Shade",
        groupName: "Group",
        layNo: "Lay No",
        ackNo: "Ack No"
      }
    },
    "material-transfer": {
      name: "Material Transfer"
    },
    grouping: {
      name: "Grouping",
      fields: {
        ...orderFields,
        warpInterval: "Length Shrinkage Interval (%)",
        weftInterval: "Width Shrinkage Interval (%)",
        widthWastePercent: "Width Wastage Cut-off (%)",
        fabAllocPlusValue: "Allocation Plus Tolerance",
        fabAllocMinusValue: "Allocation Minus Tolerance",
        minRollSplitQty: "Minimum Roll Split Length",
        groupingWastage: "Width Wastage",
        flowInfo: {
          ...flowInfoFields,
          styleColor: "Style Color",
          part: "Part",
          partName: "Part",
          placement: "Placement",
          lot: "Lot",
          itemCode: "Item Code",
          fabColor: "Fabric Color",
          fabricRequired: "Fab. Required",
          extraFabricRequired: "Fab. Required \nwith Extra",
          totalAssociation: "Total \nAssociation Qty",
          alreadyAllocated: "Already \nAllocated Qty",
          allocated: "Allocated \nFabric",
          balanceAssociation: "Balance \nAssociation Qty",
          association: "Association Qty",
          manuallyAllocated: "Manually \nAllocated Qty",
          shadeReady: "Shade \nReady",
          shrinkageReady: "Shrinkage \nReady",
          qcReady: "QC \nReady"
        },
        shadeAllocation: {
          style: "Style",
          color: "Style Color",
          destination: "Destination",
          deliveryDate: "Delivery Date",
          associatedQty: "Association Qty"
        }
      }
    },
    cutPlan: {
      name: "Cut Plan",
      fields: {
        ...orderFields,
        flowInfo: {
          ...flowInfoFields,
          styleColor: "Style Color",
          lot: "Lot",
          lotValue: "Lot",
          part: "Part",
          placement: "Placement",
          partName: "Part",
          bomCu: "BOM CU",
          deliveryDate: "Delivery Date",
          itemCode: "Item Code",
          fabColor: "Fab. Color",
          fabricPattern: "Fab. Pattern",
          repeat: "Repeat",
          width: "O. Width",
          allocatedQty: "Alloc. Fab.",
          allocated: "Alloc. Fab.",
          expCutQty: "Expected Cut Qty",
          extraPercent: "Extra Ship (%)",
          extraFab: "Extra Fab.",
          rejected: "Rejected",
          reserved: "Reserved",
          planned: "Planned in Lay",
          tentPlanned: "Planned in Lay (Exp.)",
          tentEndBits: "End Bits (Exp.)",
          endBits: "End Bits",
          shortageExcess: "Shortage/Excess",
          missing: "Missing",
          orderingCu: "BOM CU",
          layCu: "Lay CU",
          tentActualCu: "Plan CU (Exp.)",
          actualCu: "Plan CU",
          stdCu: "Std. CU"
        },
        multiPartBundling: "Planning Type",
        maxPieces: "Max. Garment Per Way",
        maxPliesInLay: "Max. Plies in a Lay",
        fabricDirection: "Fabric Direction",
        line: "Line",
        discardedWays: "Discarded Ways",
        proportionalShade: "Proportional Shade Distribution",
        reserveType: "Panel Repl. \nReservation Type",
        reserveQty: "Panel Repl. \nReservation Qty",
        stdCuAllownace: "Std. CU Allowance",
        stdCuAllowance: "Std. CU Allowance",
        cutAll: "Cut All",
        cplWarpShrPercent: "CPL Warp Shrinkage Percent",
        cplWeftShrPercent: "CPL Weft Shrinkage Percent",
        cutPlanRemarks: "Cut Plan Remarks",
        extraCutPercent: "Extra Cut (%)",
        layType: "Lay Type",
        allowOneWayCsv: "Allow One Way in Remnant",
        markerType: "Marker Type",
        plyPairPerRoll: "Ply Pairing Per Roll",
        cutConstant: "Cut Constant [4,5,6]",
        wayMaximizeConstant: "Way Maximization Constant [0, 25, 50, 75]",
        sizeExhaustConstant: "Size Exhaustion Constant [0, 25, 50, 75, 100]",
        sizeMixingConstant: "Size Mixing Constant [0, 25, 50, 75]",
        preferHigherSizeConstant: "Prefer Higher Size Constant [0, 25, 50, 75, 100]",
        mainWidthReGroupingTolerance: "Width ReGrouping Tolerance (Main)",
        remnantWidthReGroupingTolerance: "Width ReGrouping Tolerance (Remnant)",
        mainCutOffPercent: "Cut-Off Percent for Main Marker",
        endBitCsvMultiplier: "End Bit CSV Multiplier",
        plyLimit: "Ply Limit",
        maxRatio: "Maximum Ratio allowed for any size",
        skipZeroSizeRank: "Skip Zero Size Rank"
      }
    },
    bulk: {
      name: "Bulk |||| Bulk Cut Plan",
      header: {
        bulk: "Bulk Cut Order",
        pre_run: "Pre-Run Cut Order"
      },
      title: {
        pending_orders: "Pending Order",
        cut_order: "Cut Order"
      },
      fields: {
        ...orderFields,
        flowInfo: {
          ...flowInfoFields,
          styleColor: "Style Color",
          lot: "Lot",
          lotValue: "Lot",
          part: "Part",
          placement: "Placement",
          partName: "Part",
          bomCu: "BOM CU",
          deliveryDate: "Delivery Date",
          itemCode: "Item Code",
          fabColor: "Fab. Color",
          fabricPattern: "Fab. Pattern",
          repeat: "Repeat",
          width: "O. Width",
          allocatedQty: "Alloc. Fab.",
          allocated: "Alloc. Fab.",
          expCutQty: "Expected Cut Qty",
          extraPercent: "Extra Ship (%)",
          extraFab: "Extra Fab.",
          rejected: "Rejected",
          reserved: "Reserved",
          planned: "Planned in Lay",
          tentPlanned: "Planned in Lay (Exp.)",
          tentEndBits: "End Bits (Exp.)",
          endBits: "End Bits",
          shortageExcess: "Shortage/Excess",
          missing: "Missing",
          orderingCu: "BOM CU",
          layCu: "Lay CU",
          tentActualCu: "Plan CU (Exp.)",
          actualCu: "Plan CU",
          stdCu: "Std. CU"
        },
        multiPartBundling: "Planning Type",
        maxPieces: "Max. Garment Per Way",
        maxPliesInLay: "Max. Plies in a Lay",
        fabricDirection: "Fabric Direction",
        line: "Line",
        discardedWays: "Discarded Ways",
        proportionalShade: "Proportional Shade Distribution",
        reserveType: "Panel Repl. \nReservation Type",
        reserveQty: "Panel Repl. \nReservation Qty",
        stdCuAllownace: "Std. CU Allowance",
        cutAll: "Cut All",
        cplWarpShrPercent: "CPL Warp Shrinkage Percent",
        cplWeftShrPercent: "CPL Weft Shrinkage Percent",
        cutPlanRemarks: "Cut Plan Remarks",
        extraCutPercent: "Extra Cut (%)",
        extra: "Extra Cut (%)",
        cutPercent: "Extra Cut (%)",
        layType: "Lay Type",
        allowOneWayCsv: "Allow One Way in Remnant",
        markerType: "Marker Type",
        plyPairPerRoll: "Ply Pairing Per Roll",
        cutConstant: "Cut Constant [4,5,6]",
        wayMaximizeConstant: "Way Maximization Constant [0, 25, 50, 75]",
        sizeExhaustConstant: "Size Exhaustion Constant [0, 25, 50, 75, 100]",
        sizeMixingConstant: "Size Mixing Constant [0, 25, 50, 75]",
        preferHigherSizeConstant: "Prefer Higher Size Constant [0, 25, 50, 75, 100]",
        mainWidthReGroupingTolerance: "Width ReGrouping Tolerance (Main)",
        remnantWidthReGroupingTolerance: "Width ReGrouping Tolerance (Remnant)",
        mainCutOffPercent: "Cut-Off Percent for Main Marker",
        endBitCsvMultiplier: "End Bit CSV Multiplier",
        plyLimit: "Ply Limit",
        maxRatio: "Maximum Ratio allowed for any size",
        skipZeroSizeRank: "Skip Zero Size Rank"
      }
    },
    prerun: {
      name: "Pre Run |||| Pre Run"
    },
    rollPlan: {
      name: "Roll Plan",
      title: {
        cut_order: "Cut Order"
      },
      fields: {
        ...orderFields,
        setting: {
          recLayHeight: "Recommended Lay Plies",
          layHeightTolerance: "Lay Height Tolerance",
          layType: {
            all_mix: "All Mix",
            shade_wise: "Shade Wise",
            color_wise: "Color Wise",
            size_group_wise: "Size Group Wise"
          }
        },
        layslip: {
          sizeGroup: "Size Group",
          marker: "Marker",
          markerNo: "Marker No.",
          length: "Length",
          markerLength: "Marker Length",
          layLength: "Lay Length",
          shrinkage: "Shrinkage",
          way: "Way",
          layNo: "Lay No",
          cutNo: "Cut No",
          plies: "Plies",
          rollCount: "No. Of Rolls",
          width: "Width",
          pattern: "Pattern",
          csv: "CSV"
        }
      }
    },
    layslip: {
      name: "Lay Slip",
      title: {
        cut_order: "Cut Order"
      },
      fields: {
        ...orderFields,
        layslip: {
          sizeGroup: "Size Group",
          marker: "Marker",
          layLength: "Lay Length",
          way: "Way",
          layNo: "Lay No",
          cutNo: "Cut No",
          fpoLayNo: "FPO Lay No",
          plies: "Planned Plies",
          rollCount: "No. Of Rolls"
        },
        fabricUsage: {
          style: "Style",
          color: "Color",
          allocated: "Allocated",
          extra: "Extra",
          reserved: "Reserved",
          rejected: "Rejected",
          usedInLay: "Utilized",
          endBits: "End Bits",
          usedInPanel: "Panel Rep.",
          liveCu: "Live CU",
          shortageExcess: "Short/Extra Fab.",
          expShortageExcessPcs: "Exp. Short/Excess Pcs."
        }
      }
    },
    bundling: {
      name: "Numbering & Bundling",
      title: {
        cut_order: "Cut Order",
        bundle_order: "Bundle Order",
        readyToPlan: "Ready to Plan"
      },
      fields: {
        ...orderFields
      },
      bundleFields: {
        style: "STYLE",
        color: "COLOR",
        layNo: "LAY NO",
        cutNo: "CUT NO",
        extLayNo: "EXT LAY NO",
        bundleNo: "BUNDLE NO",
        sizeGroup: "SIZE GROUP",
        size: "SIZE",
        ratio: "RATIO",
        shade: "SHADE",
        shrinkage: "SHRINKAGE",
        qty: "QTY",
        start: "SERIAL START",
        end: "SERIAL END",
        rolls: "ROLL",
        supplierRolls: "SUPPLIER ROLL",
        customerFlowRefs: "BPO",
        destinations: "DESTINATION"
      }
    },
    partRecutting: {
      name: "Panel Replacement",
      fields: orderFields,
      tabs: {
        panel_summary: "Panel Summary",
        fabric_usage: "Fabric Usage",
        traceability: "Traceability"
      }
    },
    garmentRecutting: {
      name: "Garment Recutting",
      fields: orderFields
    },
    garmentRejection: {
      name: "Garment Rejection",
      fields: orderFields
    },
    orderClosure: {
      name: "Order Closure",
      fields: orderFields
    },
    report: {
      fields: orderFields,
      filter: {
        start: "Start Date",
        end: "End Date",
        fabricUom: "UOM",
        unit: "Unit",
        unitIds: "Unit",
        season: "Season",
        product: "Product",
        fabricPattern: "Fabric Pattern",
        fabricCategory: "Fabric Category",
        supplier: "Supplier",
        customer: "Customer"
      },
      arr: {
        excelColumns: {
          poCount: "Cut Orders",
          orderQty: "Order Qty",
          fpoQty: "FPO Qty",
          cutQty: "Net Cut Qty",
          netCutQty: "Net Cut Qty",
          rejectedQty: "Rejected Qty",
          allocated: "Allocated Fabric",
          returned: "Returned Fabric",
          missing: "Missing Fabric",
          unused: "Unused Fabric",
          shortageExcess: "Shortage/Excess",
          available: "Used Fabric",
          usedInLayPlanned: "Used in Planned Markers",
          usedInLayRecutting: "Used in Garment Re-cutting",
          endLoss: "End Loss",
          endBits: "Actual End Bits",
          damaged: "Damaged",
          usedInPanel: "Total Panel Recut",
          orderCloseDate: "Close Date",
          line: "Line/Floor/Factory",
          poRef: "ERP Number",
          customer: "Customer",
          season: "Season",
          style: "Style",
          styleColor: "Style Color",
          styleNo: "Style No",
          part: "Part",
          lot: "Lot",
          shortage: "Shortage",
          excess: "Excess",
          fabricUsed: "Fabric Used",
          wastage: "Total Wastage",
          wastagePercent: "Wastage (%)",
          orderingCu: "BOM CU",
          stdCu: "Std. CU",
          planCu: "Plan CU",
          actualCu: "Actual CU",
          misCu: "MIS CU",
          cuDiff: "CU Diff. (in CM)",
          markerEfficiency: "Marker Efficiency",
          supplier: "Supplier",
          fabricPattern: "Fab Pattern",
          fabDirection: "Fab Direction",
          isCsv: "CSV",
          fabRepeat: "Fab Repeat",
          width: "Fab Bom Width (in CM)",
          actualWidth: "Fab Actual Width (in CM)",
          alerts: "Alerts",
          remarks: "Remarks",
          avgRollLength: "Average Roll Length",
          splitCount: "No of Splitting",
          itemCode: "FAB Item Code",
          markerUpdatedBy: "Marker Updated By",
          unit: "Unit",
          fpo: "FPO No",
          product: "Product",
          color: "Style Color",
          lotValue: "Lot",
          inseams: "inseams",
          destinations: "Destinations",
          deliveries: "deliveries",
          delModes: "Delivery Modes",
          customerFlowRefs: "BPO",
          flowRefs: "Line ID",
          delFlowRefs: "Delivery Line ID",
          cumCutQty: "Cum. Cut Qty",
          startDate: "Start Date",
          endDate: "End Date",
          productList: "Products",
          customerList: "Customers",
          date: "Date",
          widthDeviation: "Width Deviation",
          mill: "mill",
          customerName: "Customer",
          seasonName: "Season",
          productName: "Product",
          status: "status",
          cuttingClosedDate: "Cutting End Date"
        }
      },
      wastage: {
        month: "Month",
        poCount: "Cut Orders",
        cutQty: "Cut Qty",
        wastage: "Wastage",
        wastagePercent: "Wastage (%)",
        date: "Date",
        poRef: "ERP No",
        customer: "Customer",
        color: "Color",
        part: "Part",
        lot: "Lot",
        csv: "CSV",
        endBits: "End Bits",
        endBitsPercent: "end Bits (%)",
        damaged: "Damaged",
        damagedPercent: "Damaged (%)",
        fabricUsed: "Fabric Used"
      },
      endbit: {
        serialNo: "Sl. No.",
        rollNumber: "Roll Number",
        color: "Style Color",
        shade: "Shade",
        length: "Length",
        endBits: "End Bits",
        remarks: "Remarks"
      },
      drr: {
        columns: {
          poRef: "ERP No.",
          customerName: "Customer",
          seasonName: "Season",
          productName: "Product",
          style: "Style Name",
          styleNo: "Style No",
          color: "Style Color",
          effPartName: "Part",
          orderQty: "Order Qty",
          extra: "Extra Ship (%)",
          shortShipPercent: "Short Ship (%)",
          cutQty: "Cut Qty",
          rejectedQty: "Rejected Qty",
          bomCu: "BOM CU",
          planCu: "Plan CU",
          stdCu: "Std. CU",
          actualCu: "Actual CU",
          misCu: "MIS CU",
          markerEfficiency: "Marker Efficiency",
          status: "Status",
          itemCode: "Item Code",
          itemColor: "Item Color",
          allocated: "Allocated",
          returned: "Returned",
          excess: "Excess",
          shortage: "Shortage",
          missing: "Missing",
          unused: "Unused",
          usedInLay: "Used in Lay",
          usedInPanel: "Used in Panel",
          endLoss: "End Loss",
          damaged: "Damaged",
          endBits: "Actual End Bits",
          desc: "Description",
          total: "Total",
          totalPercent: "Total(%)"
        }
      },
      cutting: {
        date: "Date",
        unit: "Unit",
        poRef: "ERP No",
        fpo: "FPO No",
        customer: "Customer",
        season: "Season",
        product: "Product",
        style: "Style Name",
        color: "Style Color",
        part: "Part",
        lotValue: "Lot",
        inseams: "Inseam",
        destinations: "Destination",
        deliveries: "Delivery Date",
        delModes: "Delivery Modes",
        customerFlowRefs: "BPO",
        delFlowRefs: "Delivery Line ID",
        flowRefs: "Line ID",
        orderQty: "Order Qty",
        fpoQty: "FPO Qty",
        cutQty: "Cut Qty",
        cumCutQty: "Cum. Cut Qty"
      },
      closurePending: {
        pendingSince: "Pending Since",
        state: "State",
        unit: "Unit",
        poRef: "ERP No",
        fpo: "FPO No",
        customer: "Customer",
        season: "Season",
        product: "Product",
        style: "Style Name",
        color: "Style Color",
        part: "Part",
        lotValue: "Lot",
        inseams: "inseam",
        destinations: "Destination",
        deliveries: "Delivery Date",
        delModes: "Delivery Mode",
        customerFlowRefs: "BPO",
        flowRefs: "Line ID",
        delFlowRefs: "Delivery Line ID",
        orderQty: "Order Qty",
        fpoQty: "FPO Qty",
        cutQty: "Cut Qty",
        cutQtyPercent: "Cut Qty (%)",
        cutCompletionDate: "Cut Completion Date"
      }
    },
    users: {
      name: "User |||| Users",
      page: {
        create: "Create User",
        edit: "Edit User",
        view: "View User",
        upload: "Upload User"
      },
      title: {
        excel_file: "Excel File"
      },
      error: {
        roles_required: "Roles is required.",
        customer_required: "Customer is required for role: %{role}.",
        warehouse_required: "Warehouse is required for role: %{role}.",
        not_valid_selection: "Admin role cannot be combined with other roles"
      },
      errors: {
        invalid_username: "Invalid Username. Can use letters (a-z,A-Z), numbers (0-9), hyphen (-), underscore (_) only.",
        invalid_email: "Invalid Email."
      },
      message: {
        activated: "User activated successfully.",
        deactivated: "User deactivated successfully."
      },
      fields: {
        id: "ID",
        unitIds: "Units",
        fullName: "Full Name",
        username: "Username",
        email: "Email",
        mobile: "Mobile",
        roles: "Roles",
        roleIds: "Roles",
        departmentId: "Department"
      }
    },
    customers: {
      name: "Customer |||| Customers",
      page: {
        create: "Create Customer",
        edit: "Edit Customer"
      },
      fields: {
        id: "ID",
        unitIds: "Units",
        name: "Customer",
        code: "Code",
        desc: "Description"
      }
    },
    alertParameters: {
      name: "Alert Parameter |||| Alert Parameters",
      fields: {
        id: "ID",
        unitIds: "Units",
        parameter: "Parameter",
        minusTolerance: "Tolerance (-)",
        plusTolerance: "Tolerance (+)",
        toleranceUnit: "Tolerance Unit",
        desc: "Description",
        alertParameterItem: {
          name: "",
          reason: "Reason",
          impact: "Impact"
        }
      }
    },
    suppliers: {
      name: "Supplier |||| Suppliers",
      fields: {
        id: "ID",
        unitIds: "Units",
        name: "Supplier",
        desc: "Description"
      }
    },
    seasons: {
      name: "Season |||| Seasons",
      fields: {
        id: "ID",
        unitIds: "Units",
        name: "Season",
        desc: "Description"
      }
    },
    tables: {
      name: "Table |||| Tables",
      fields: {
        id: "ID",
        unitIds: "Units",
        name: "Table",
        desc: "Description"
      }
    },
    units: {
      name: "Unit |||| Units",
      fields: {
        name: "Unit",
        desc: "Description",
        unitId: "Unit Id"
      },
      errors: {
        invalid_unit_id: "Invalid Unit Id. Can use letters (a-z,A-Z), numbers (0-9), hyphen (-), underscore (_) only."
      }
    },
    departments: {
      name: "Department |||| Departments",
      fields: {
        id: "ID",
        unitIds: "Units",
        name: "Department",
        desc: "Description"
      }
    },
    warehouses: {
      name: "Warehouse |||| Warehouses",
      fields: {
        id: "ID",
        unitIds: "Units",
        name: "Warehouse",
        desc: "Description"
      },
      errors: {
        invalid_code: "Invalid Code. Can use letters (a-z,A-Z), numbers (0-9), hyphen (-), underscore (_) only."
      }
    },
    "system-activities": {
      name: "System Activity |||| System Activities",
      fields: {
        name: "System Activity",
        searchText: "Entity Value",
        createdAt: "Time",
        createdBy: "User"
      }
    },
    reCutParts: {
      name: "Recutting Part |||| Recutting Parts",
      fields: {
        name: "Part",
        category: "Category"
      }
    },
    bundleParts: {
      name: "Bundle Part |||| Bundle Parts",
      fields: {
        name: "Template Name",
        parts: "Parts"
      }
    },
    "size-chart": {
      name: "Size Chart",
      fields: {
        customerId: "Customer",
        customerName: "Customer",
        productId: "Product",
        productName: "Product",
        name: "Size Range",
        modifiedAt: "Updated On",
        modifiedBy: "Updated By"
      }
    },
    sizes: {
      name: "Size |||| Sizes",
      fields: {
        name: "Size",
        desc: "Description"
      }
    },
    "fabric-patterns": {
      name: "Fabric Pattern |||| Fabric Patterns",
      fields: {
        id: "ID",
        unitIds: "Units",
        name: "Fabric Pattern",
        desc: "Description"
      }
    },
    products: {
      name: "Product |||| Products",
      fields: {
        id: "ID",
        unitIds: "Units",
        name: "Product",
        bundleParts: "Bundle Parts",
        replacementPanels: "Replacement Panels",
        serialResetAt: "Serial Reset At",
        bundleResetAt: "Bundle Reset At",
        bundleBreakAt: "Bundle Break At",
        bundleSizeSort: "Bundling - Size Sorting",
        bundleSerialSort: "Numbering - Serial Sorting",
        desc: "Description",
        isSet: "Is Set?"
      }
    },
    downloads: {
      name: "Template |||| Templates"
    },
    "fabric-categories": {
      name: "Fabric Category |||| Fabric Categories",
      fields: {
        id: "ID",
        unitIds: "Units",
        name: "Fabric Category",
        desc: "Description"
      }
    },
    externalApps: {
      name: "Registered App |||| Registered Apps",
      fields: {
        name: "Application",
        appId: "App Id",
        integrationType: "Integration Type",
        enabled: "Enabled",
        serviceClass: "Service Class",
        authConfig: "Auth Config",
        authServiceClass: "Auth Service Class"
      }
    },
    apiKeys: {
      name: "Api Key |||| Api Keys",
      fields: {
        appId: "App Id",
        active: "Active"
      }
    },
    help: {
      name: "Help Center"
    },
    manual: {
      name: "User Manual"
    },
    test: {
      name: "Test Page"
    },
    scheduledTask: {
      name: "Scheduled Task |||| Scheduled Tasks",
      pageHeader: {
        home: "Scheduled Task"
      },
      button: {
        stop: "Stop",
        cancel: "Cancel"
      }
    }
  },
  js: {
    action: {
      delete: "Delete",
      show: "Show",
      view: "View",
      list: "List",
      history: "History",
      save: "Save",
      next: "Next",
      submit: "Submit",
      create: "Create",
      edit: "Edit",
      upload: "Upload",
      download: "Download",
      sort: "Sort",
      close: "close",
      cancel: "Cancel",
      clear_input_value: "Clear value",
      undo: "Undo",
      refresh: "Refresh",
      add: "Add",
      remove: "Remove",
      filter: "Filter",
      add_filter: "Add filter",
      remove_filter: "Remove this filter",
      back: "Back",
      bulk_actions: "%{smart_count} selected"
    },
    boolean: {
      true: "Yes",
      false: "No"
    },
    page: {
      list: "%{name}",
      edit: "%{name} #%{id}",
      show: "%{name} #%{id}",
      create: "Create %{name}",
      bulk_upload: "%{name} Bulk Upload",
      dashboard: "Dashboard",
      not_found: "Not Found",
      loading: "Loading"
    },
    tab: {
      show: "View %{name}",
      create: "Create %{name}",
      edit: "Update %{name}"
    },
    input: {
      file: {
        upload_several: "Drop some files to upload, or click to select one.",
        upload_single: "Drop a file to upload, or click to select it."
      },
      image: {
        upload_several: "Drop some pictures to upload, or click to select one.",
        upload_single: "Drop a picture to upload, or click to select it."
      },
      references: {
        all_missing: "Unable to find references data.",
        many_missing: "At least one of the associated references no longer appears to be available.",
        single_missing: "Associated reference no longer appears to be available."
      }
    },
    message: {
      yes: "Yes",
      no: "No",
      are_you_sure: "Are you sure?",
      about: "About",
      not_found: "Either you typed a wrong URL, or you followed a bad link.",
      loading: "The page is loading, just a moment please",
      invalid_form: "The form is not valid. Please check for errors",
      delete_title: "Delete %{name} #%{id}",
      delete_content: "Are you sure you want to delete this item?",
      bulk_delete_title: "Delete %{name} |||| Delete %{smart_count} %{name} items",
      bulk_delete_content: "Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?",
      data_not_available: "Data not available",
      drop_file: "Drag and drop file here, or click to select file",
      file_size_limit: "File size limit exception. Allowed file size is %{allowed_file_size} MB."
    },
    navigation: {
      no_results: "No results found",
      no_more_results: "The page number %{page} is out of boundaries. Try the previous page.",
      page_out_of_boundaries: "Page number %{page} out of boundaries",
      page_out_from_end: "Cannot go after last page",
      page_out_from_begin: "Cannot go before page 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} of %{total}",
      next: "Next",
      prev: "Prev"
    },
    auth: {
      username: "Username",
      password: "Password",
      sign_in: "Sign in",
      sign_in_error: "Authentication failed. username or password you have entered is invalid.",
      logout: "Logout",
      password_reset_success: "Password reset successfully.",
      password_change_success: "Password changed successfully."
    },
    notification: {
      updated: "%{element} updated successfully. |||| %{smart_count} %{element} updated successfully.",
      created: "%{element} created successfully.",
      deleted: "%{element} deleted successfully. |||| %{smart_count} %{element} deleted successfully.",
      bad_item: "Incorrect %{element}",
      item_doesnt_exist: "%{element} does not exist",
      http_error: "Server communication error",
      canceled: "Action cancelled",
      uploaded: "%{element} uploaded successfully."
    },
    validation: {
      required: "Required",
      minLength: "Must be %{min} characters at least",
      maxLength: "Must be %{max} characters or less",
      minValue: "Must be at least %{min}",
      maxValue: "Must be %{max} or less",
      betweenValue: "Must be between (%{min}, %{max})",
      number: "Must be a number",
      email: "Must be a valid email",
      oneOf: "Must be one of: %{options}",
      regex: "Must match a specific format (regexp): %{pattern}"
    },
    alert: {
      confirm_delete: "Delete %{record}?",
      form_error: "Form has error. Review form errors."
    }
  }
};

export default en;
